module.exports = "/packs/images/homepage/activity/gymnastic_retina~199a64ba05ee31aae979484687ff56f4.jpg";